import { FC } from "react";
import { ImageCollection } from "common/config/media.config";
import "./Loading.scss";
import Spinner from "common/components/base/spinner/Spinner";

const Loading: FC = () => {
  return (
    <div className={`loading-page`}>
      {/* <img src={ImageCollection.XM_LOGO_SMALL} height={80} width={80} /> */}
      <Spinner size={60} />
      <div className="info-container">
        <span>Loading</span>
        <span className="blink">...</span>
      </div>
    </div>
  );
};

export default Loading;
